"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

import { Collections } from "../data/collections";

const formatDateToFrench = (dateStr: string) => {
  const [month, year] = dateStr.split("/");
  const months = {
    "01": "JANVIER",
    "02": "FÉVRIER",
    "03": "MARS",
    "04": "AVRIL",
    "05": "MAI",
    "06": "JUIN",
    "07": "JUILLET",
    "08": "AOUT",
    "09": "SEPTEMBRE",
    "10": "OCTOBRE",
    "11": "NOVEMBRE",
    "12": "DÉCEMBRE",
  };

  return `${months[month as keyof typeof months]} 20${year}`;
};

export default function LastCollection() {
  return (
    <div className="flex w-full flex-col gap-8 p-4 px-4 py-20 ph:px-24 md:flex-row md:px-48 lg:px-72 xl:px-96">
      <div className="relative aspect-[804/714] w-full md:w-1/2">
        <Image
          src={Collections[0].images[0]}
          alt="Wedding Hairstyle"
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          className="object-cover"
        />
      </div>

      <div className="flex flex-col gap-4 space-y-8 md:w-1/2 lg:gap-8">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <h3 className="text-lg ph:text-xl">
              {formatDateToFrench(Collections[0].date)}
            </h3>
            <h2 className="text-4xl uppercase ph:text-5xl">
              {Collections[0].title}
            </h2>
          </div>
          <div className="flex flex-col gap-4 xl:gap-6">
            {Collections[0].descriptionParagraphs.map((paragraph, index) => (
              <p key={index} className="text-base leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div>
          <Link
            href={`/collections/${Collections[0].id}`}
            className="group relative inline-block pb-[2px]"
          >
            <span>VOIR LA GALERIE PHOTO</span>
            <div className="absolute bottom-0 left-0 h-[1px] w-full bg-black">
              <div className="h-full w-0 bg-gold transition-all duration-300 ease-out group-hover:w-full"></div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
